import { useAuth } from "@/src/contexts/auth.context";
import { PostComment, ReactionType } from "@/src/models/post.model";
import {
    useGetUserCommentReaction,
    useReactToCommentMutation,
} from "@/src/services/api/posts/posts.hooks";

export const useReactToComment = (comment: PostComment) => {
  const { user } = useAuth();
  // `itemId`, not `userID` — the latter is not on BlocksUser, so this silently
  // resolved to "" and every comment reaction was written/looked up for the
  // empty user: the mutation no-oped and the UI never showed the liked state.
  const userId = user?.itemId ?? "";

  const { data: userReaction } = useGetUserCommentReaction(
    comment.ItemId,
    userId,
  );
  const { mutate } = useReactToCommentMutation();

  const handleReact = (newReaction: ReactionType | null) => {
    mutate({
      commentId: comment.ItemId,
      postId: comment.postId,
      userId,
      newReaction,
      previousReaction: userReaction?.type ?? null,
      currentCounts: comment.reactionCount,
      existingReactionId: userReaction?.id,
    });
  };

  return { userReaction, handleReact };
};
